/**
 * @module geo/actions/creators
 *
 */
import { promiseActionCreator } from "../../helpers/observable.to.promise";
import { DISABLE_FUNCTIONALITY } from "../../payload/facade";
import { ENABLE_FUNCTIONALITY } from "../../payload/facade/ENABLE_FUNCTIONALITY";
import { Acknowledged } from "../../payload/response/acknowledged";
import { actionCreator } from "../helpers/actions.creator.builder";
import { ActionCreator } from "../helpers/fsa";
import { TypeKeyActions } from "../types.key.action";

/**
 *  return an action to enable and launch a functionality
 * @since v 2.0.1
 */
export const enableFunctionalityCreator = actionCreator<ENABLE_FUNCTIONALITY>(
  TypeKeyActions.ENABLE_FUNCTIONALITY
) as ActionCreator<ENABLE_FUNCTIONALITY>;
/**
 * action type for enable functionality
 * @since v 2.0.1
 */
export const enableFunctionalityAsyncCreator = actionCreator.async<
  ENABLE_FUNCTIONALITY,
  Acknowledged,
  any
>(TypeKeyActions.ENABLE_FUNCTIONALITY);
/**
 * return an async action to enable and launch a functionality
 *  @since v 2.0.1
 * @private
 * @hidden
 */
export const enableFunctionalityCreatorP = promiseActionCreator(
  enableFunctionalityCreator,
  [
    enableFunctionalityAsyncCreator.done.type,
    enableFunctionalityAsyncCreator.failed.type
  ]
);

/**
 * return an action creator to disable a functionality
 * @since v 2.0.1
 */
export const disableFunctionalityCreator = actionCreator<DISABLE_FUNCTIONALITY>(
  TypeKeyActions.DISABLE_FUNCTIONALITY
) as ActionCreator<DISABLE_FUNCTIONALITY>;
/**
 * action type for disable functionality
 * @since v 2.0.1
 */
export const disableFunctionalityAsyncCreator = actionCreator.async<
  DISABLE_FUNCTIONALITY,
  Acknowledged,
  Error
>(TypeKeyActions.DISABLE_FUNCTIONALITY);
/**
 *  return an async action to disable a functionality
 *  @since v 2.0.1
 * @private
 * @hidden
 */
export const disableFunctionalityCreatorP = promiseActionCreator(
  disableFunctionalityCreator,
  [
    disableFunctionalityAsyncCreator.done.type,
    disableFunctionalityAsyncCreator.failed.type
  ]
);
